const formatPrioritizedValue = (primary, secondary) => ({
  primary,
  secondary,
});

export default formatPrioritizedValue;
